import { Button } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

interface Props {
  address: any;
  onChange: () => void;
}

export const SelectedAddressMobile = ({
  address,
  onChange,
}: Props) => {
  if (!address) return null;

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e5e5",
        borderRadius: "4px",
        padding: "12px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "10px",
        }}
      >
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px",
              fontWeight: 600,
              color: "#ef8d22",
              textTransform: "uppercase",
            }}
          >
            <LocationOnIcon sx={{ fontSize: "20px" }} />
            {address.address_type || "Address"}
          </div>

          <div
            style={{
              fontSize: "13px",
              color: "#111",
              fontWeight: 500,
              marginTop: "4px",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              whiteSpace: "normal",
              lineHeight: "1.5",
            }}
          >
            {[
              address.flat_no,
              address.landmark,
                address.area,
                address.address_3,
                address.street,
                address.address_1,
                address.address_2,
            ]
                .filter((part) => part && String(part).trim() !== "")
                .filter((part, index, parts) => parts.indexOf(part) === index)
              .join(", ")}
          </div>
        </div>

        <Button
          variant="outlined"
          size="small"
          onClick={onChange}
          sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
        >
          Change
        </Button>
      </div>
    </div>
  );
};